// extracted by mini-css-extract-plugin
export default {"list":"ProductList_list__lGhH7","list__header":"ProductList_list__header__sdvjl","empty":"ProductList_empty__VHlxd","product__grid":"ProductList_product__grid__UweqA"};